import { cn } from "@/lib/cn";

export interface SegmentOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentControlProps<T extends string> {
  label: string;
  options: SegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

/** 原型基元：`.segment-control` + `.segment-button.is-active`。 */
export function SegmentControl<T extends string>({
  label,
  options,
  value,
  onChange,
  className,
}: SegmentControlProps<T>) {
  return (
    <div className={cn("segment-control", className)} aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={cn("segment-button", option.value === value && "is-active")}
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
